export function useStorage(key: string) {
  return {
    get: () => localStorage.getItem(key) || "",
    set: (value: string | undefined) => {
      if (value) localStorage.setItem(key, value);
    },
    remove: () => localStorage.removeItem(key),
  };
}
